import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import styled from 'styled-components';
import { useTranslations } from '../../hooks/use_translations.js';
import { spacing2x, spacing4x, spacing1x } from '../../styles/spacing.js';
import { useThemeContext } from '../../styles/themes/themes.js';
import { Alert } from '../Alert/Alert.js';
import { Button } from '../Button/Button.js';
import { IconClose } from '../Icons/IconClose.js';
import { BannerText } from './components/BannerText.js';
import { jsxs, jsx } from 'react/jsx-runtime';

var _excluded = ["CTA", "html", "message", "onDismiss", "variant"];
var minHeightInPx = 40;
var StyledAlert = styled(Alert).withConfig({
  displayName: "Banner__StyledAlert",
  componentId: "sc-r2zzlc-0"
})(["&&{position:relative;display:flex;padding:", ";min-height:", "px;", ";}"], spacing2x + " " + spacing4x, minHeightInPx, function (props) {
  switch (props.variant) {
    case "error":
      return "background-color: #FAD2D6";
    case "info":
      return "background-color: #D1E8FD";
    case "success":
      return "background-color: #CCE8D2";
    case "warning":
    case "progress":
      return "background-color: #FFF3CD";
  }
});
var BannerTextWrapper = styled.div.withConfig({
  displayName: "Banner__BannerTextWrapper",
  componentId: "sc-r2zzlc-1"
})(["&&{display:flex;flex-grow:1;padding-inline-end:", ";}"], function (_ref) {
  var hasDismissButton = _ref.hasDismissButton;
  return hasDismissButton ? "34px" : spacing2x;
});
var DismissButton = styled(Button).withConfig({
  displayName: "Banner__DismissButton",
  componentId: "sc-r2zzlc-2"
})(["&&{position:absolute;top:", "px;inset-inline-end:", ";transform:translateY(-50%);}"], minHeightInPx / 2, spacing1x);
var Banner = /*#__PURE__*/React.forwardRef(function Banner2(props, ref) {
  var CTA = props.CTA,
    html = props.html,
    message = props.message,
    onDismiss = props.onDismiss,
    _props$variant = props.variant,
    variant = _props$variant === void 0 ? "info" : _props$variant,
    rest = _objectWithoutProperties(props, _excluded);
  var _useThemeContext = useThemeContext(),
    localization = _useThemeContext.localization;
  var _useTranslations = useTranslations(localization === null || localization === void 0 ? void 0 : localization.translations),
    t = _useTranslations.t;
  return /*#__PURE__*/jsxs(StyledAlert, _objectSpread(_objectSpread({}, rest), {}, {
    borderWidth: 0,
    hideStrip: true,
    type: "banner",
    variant: variant ? variant : "info",
    ref: ref,
    children: [/*#__PURE__*/jsx(BannerTextWrapper, {
      hasDismissButton: !!onDismiss,
      children: /*#__PURE__*/jsx(BannerText, {
        html: html,
        message: message,
        CTA: CTA
      })
    }), onDismiss && /*#__PURE__*/jsx(DismissButton, {
      hideLabel: true,
      label: t("Banner.dismissButton"),
      onClick: function onClick(e) {
        return onDismiss(e);
      },
      startAdornment: IconClose,
      variant: "ghost"
    })]
  }));
});
Banner.displayName = "Banner";

export { Banner };
